import SalesCoachMain from "@/features/salesCoach/components/SalesCoachMain";
import React from "react";

const SalesCoach = () => {
  return <SalesCoachMain />;
};

export default SalesCoach;
